import type { ComplianceWorkflowDto } from '../services/api'
import type { WorkflowDefinition, WorkflowStep, WorkflowStepKey } from './types'

export function mapApiWorkflowToDefinition(dto: ComplianceWorkflowDto): WorkflowDefinition {
  const steps: WorkflowStep[] = [...dto.steps]
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map((s) => ({
      key: s.stepKey as WorkflowStepKey,
      sortOrder: s.sortOrder,
      title: s.title,
      shortLabel: s.shortLabel,
      description: s.description,
      primaryRoute: s.primaryRoutePath,
      routePatterns: s.routePatterns.length > 0 ? s.routePatterns : [s.primaryRoutePath],
    }))

  return {
    id: dto.id,
    code: dto.code,
    name: dto.name,
    version: dto.version,
    steps,
  }
}
